module.exports = __webpack_public_path__ + "img/braendz-blue-frame.3b484ec4.svg";